var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z",
    fill: "#3B4346"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53414 11.7624L13.0852 8.21288L16.6377 11.7653L18.7027 9.69877L13.0852 4.08L7.46763 9.69737L9.53414 11.7624ZM3.9422 13.2219L6.00795 11.1562L8.0737 13.2219L6.00795 15.2876L3.9422 13.2219ZM13.0856 18.2317L9.53461 14.6808L7.46521 16.7443L7.4681 16.7472L13.0856 22.3632L18.7032 16.7443L18.7046 16.7429L16.6381 14.6794L13.0856 18.2317ZM18.0937 13.2224L20.1595 11.1567L22.2252 13.2224L20.1595 15.2881L18.0937 13.2224ZM13.0855 11.1241L15.1809 13.2209H15.1824L15.1809 13.2223L13.0855 15.3191L10.9901 13.2252L10.9873 13.2209L10.9901 13.218L11.3569 12.8512L11.536 12.6736L13.0855 11.1241Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg56);
export default __webpack_public_path__ + "static/media/56.eb64bb536e913eed0b357ed040be8915.svg";
export { ForwardRef as ReactComponent };